import React from 'react';
import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ETFSearcher from '../components/ETFSearcher';


export default function DashboardBis() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <AppBar position="sticky" color="transparent" elevation={0} className="no-print">
        <Toolbar sx={{ maxWidth: 1240, width: '100%', mx: 'auto', py: 1 }}>
          <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontWeight: 800 }}>
            ZoomETF
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button onClick={() => navigate('/search')}>Recherche</Button>
            <Button onClick={() => navigate('/about')}>Comprendre</Button>
            <Button onClick={() => navigate('/settings')}>Affichage</Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 9 } }}>
        <ETFSearcher />
      </Container>

      <Box component="footer" className="no-print" sx={{ borderTop: 1, borderColor: 'divider', py: 3 }}>
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary">
            ZoomETF est un outil pédagogique d’exploration. Il ne fournit pas de conseil financier personnalisé.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
